import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { environment } from '../../../environments/environment';

const isBearerTokenEnabled = (): boolean => {
  const flag = (environment as any).bearer_token;
  if (typeof flag === 'boolean') {
    return flag;
  }
  return String(flag ?? '').trim().toLowerCase() !== 'false';
};

@Injectable({
  providedIn: 'root',
})
export class KeycloakInitService {
  constructor(
    private keycloakService: KeycloakService,
    private router: Router
  ) {}
  async initKeycloak(): Promise<void> {
    try {
      await this.keycloakService.init({
        config: {
          url: environment.KEYCLOAK_URL,
          realm: environment.KEYCLOAK_REALM,
          clientId: environment.KEYCLOAK_CLIENT_ID,
        },
        initOptions: {
          onLoad: 'check-sso',
          checkLoginIframe: false,
          silentCheckSsoRedirectUri:
            window.location.origin + '/assets/silent-check-sso.html',
          pkceMethod: 'S256',
        },
        enableBearerInterceptor: isBearerTokenEnabled(),
        bearerPrefix: 'Bearer',
      });
      if (this.keycloakService.isLoggedIn()) {
        return Promise.resolve();
      }
    } catch (error) {
      console.error('Keycloak initialization failed', error);
      throw error;
    }
  }
}
